"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var errors_exports = {};
__export(errors_exports, {
  MagicLinkErrorCode: function MagicLinkErrorCode() {
    return import_shared.MagicLinkErrorCode;
  },
  hocChildrenNotAFunctionError: function hocChildrenNotAFunctionError() {
    return _hocChildrenNotAFunctionError;
  },
  invalidStateError: function invalidStateError() {
    return _invalidStateError;
  },
  isClerkAPIResponseError: function isClerkAPIResponseError() {
    return import_shared.isClerkAPIResponseError;
  },
  isKnownError: function isKnownError() {
    return import_shared.isKnownError;
  },
  isMagicLinkError: function isMagicLinkError() {
    return import_shared.isMagicLinkError;
  },
  isMetamaskError: function isMetamaskError() {
    return import_shared.isMetamaskError;
  },
  multipleChildrenInButtonComponent: function multipleChildrenInButtonComponent() {
    return _multipleChildrenInButtonComponent;
  },
  multipleClerkProvidersError: function multipleClerkProvidersError() {
    return _multipleClerkProvidersError;
  },
  noClerkProviderError: function noClerkProviderError() {
    return _noClerkProviderError;
  },
  noFrontendApiError: function noFrontendApiError() {
    return _noFrontendApiError;
  },
  noGuaranteedLoadedError: function noGuaranteedLoadedError() {
    return _noGuaranteedLoadedError;
  },
  noGuaranteedUserError: function noGuaranteedUserError() {
    return _noGuaranteedUserError;
  },
  unsupportedNonBrowserDomainOrProxyUrlFunction: function unsupportedNonBrowserDomainOrProxyUrlFunction() {
    return _unsupportedNonBrowserDomainOrProxyUrlFunction;
  }
});
module.exports = __toCommonJS(errors_exports);
var import_shared = require("@clerk/shared");
var _noFrontendApiError = "Clerk: You must add the frontendApi prop to your <ClerkProvider>";
var _noClerkProviderError = "Clerk: You must wrap your application in a <ClerkProvider> component.";
var _noGuaranteedLoadedError = function _noGuaranteedLoadedError(hookName) {
  return "Clerk: You're calling ".concat(hookName, " before there's a guarantee the client has been loaded. Call ").concat(hookName, " from a child of <SignedIn>, <SignedOut>, or <ClerkLoaded>, or use the withClerk() HOC.");
};
var _noGuaranteedUserError = function _noGuaranteedUserError(hookName) {
  return "Clerk: You're calling ".concat(hookName, " before there's a guarantee there's an active user. Call ").concat(hookName, " from a child of <SignedIn> or use the withUser() HOC.");
};
var _multipleClerkProvidersError = "Clerk: You've added multiple <ClerkProvider> components in your React component tree. Wrap your components in a single <ClerkProvider>.";
var _hocChildrenNotAFunctionError = "Clerk: Child of WithClerk must be a function.";
var _multipleChildrenInButtonComponent = function _multipleChildrenInButtonComponent(name) {
  return "Clerk: You've passed multiple children components to <".concat(name, "/>. You can only pass a single child component or text.");
};
var _invalidStateError = "Invalid state. Feel free to submit a bug or reach out to support here: https://clerk.com/support";
var _unsupportedNonBrowserDomainOrProxyUrlFunction = "Unsupported usage of domain or proxyUrl. The usage of domain or proxyUrl as function is not supported in non-browser environments.";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MagicLinkErrorCode: MagicLinkErrorCode,
  hocChildrenNotAFunctionError: _hocChildrenNotAFunctionError,
  invalidStateError: _invalidStateError,
  isClerkAPIResponseError: isClerkAPIResponseError,
  isKnownError: isKnownError,
  isMagicLinkError: isMagicLinkError,
  isMetamaskError: isMetamaskError,
  multipleChildrenInButtonComponent: _multipleChildrenInButtonComponent,
  multipleClerkProvidersError: _multipleClerkProvidersError,
  noClerkProviderError: _noClerkProviderError,
  noFrontendApiError: _noFrontendApiError,
  noGuaranteedLoadedError: _noGuaranteedLoadedError,
  noGuaranteedUserError: _noGuaranteedUserError,
  unsupportedNonBrowserDomainOrProxyUrlFunction: _unsupportedNonBrowserDomainOrProxyUrlFunction
});